// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2NE8n","header":"PatientQuestionnaire_header__38S8d","info":"PatientQuestionnaire_info__3ixor"};